import { useForm } from "@inertiajs/react";
import { type SubmitEvent } from "react";
import MediaGroupForm from "@/pages/media_group_participants/_form";
import OnboardingShell from "@/shared/onboarding/OnboardingShell";
import { onboardingLayout } from "@/layouts/OnboardingLayout";
import type { MediaGroupFormData } from "@/types/shared";
import type { OnboardingMediaGroupProps } from "@/types/onboarding";

// The regular media group form, posted to its regular endpoint with
// `onboarding=1` so MediaGroupParticipantsController sends them back here.
export default function OnboardingMediaGroup({
  errors,
  ...shell
}: OnboardingMediaGroupProps) {
  const { data, setData, post, processing } = useForm<MediaGroupFormData>({
    participant: {
      name: "",
      location: "",
      email: "",
      phone_number: "",
      instagram: "",
      youtube: "",
      flickr: "",
      facebook: "",
      tiktok: "",
      threads: "",
    },
    media_group: {
      primary_outlet: "",
      portfolio_link: "",
      listing: "photography",
      logo: null,
    },
  });

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    post("/media_group_participant?onboarding=1", { forceFormData: true });
  };

  return (
    <OnboardingShell
      {...shell}
      title="Set up your media group"
      subtitle="Organizers see this when you apply to shoot a media day. Just you? A group of one is fine."
    >
      <MediaGroupForm
        data={data}
        setData={setData}
        onSubmit={handleSubmit}
        processing={processing}
        errors={errors ?? undefined}
        title="Media group"
        subtitle="You can change any of this later."
        submitLabel="Save and continue"
        cancelPath={null}
      />
    </OnboardingShell>
  );
}

OnboardingMediaGroup.layout = onboardingLayout;
